import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=7a738eb0&scoped=true"
import script from "./AboutSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a738eb0",
  null
  
)

export default component.exports